export default function ManagerDashboard() {
  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-bold text-green-600">Manager Dashboard</h1>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-gradient-to-r from-green-400 to-green-600 text-white p-6 rounded-xl shadow-lg hover:scale-105 transform transition">
          <h2 className="text-xl font-semibold">Team Members</h2>
          <p className="text-3xl mt-2">8</p>
        </div>

        <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-white p-6 rounded-xl shadow-lg hover:scale-105 transform transition">
          <h2 className="text-xl font-semibold">Pending Approvals</h2>
          <p className="text-3xl mt-2">3</p>
        </div>

        <div className="bg-gradient-to-r from-purple-400 to-purple-600 text-white p-6 rounded-xl shadow-lg hover:scale-105 transform transition">
          <h2 className="text-xl font-semibold">Announcements</h2>
          <p className="text-3xl mt-2">2</p>
        </div>
      </div>

      {/* Team Members List */}
      <div className="bg-white p-6 rounded-xl shadow-lg">
        <h2 className="text-2xl font-semibold mb-4">Team Members</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>John Doe - Sales</li>
          <li>Jane Smith - HR</li>
          <li>Robert Brown - IT</li>
        </ul>
      </div>
    </div>
  );
}
